export default [
    {
        path: '/platinum/routes',
        props: true,
        component: () => import('@/views/PlatinumRoute'),
    },
];
